import dayjs from "dayjs";

export const statusColorMap = {
  OPEN: "informative",
  INPROGRESS: "informative",
  WAITINGPARTS: "neutral",
  READYTOPICKUP: "alert",
  CLOSED: "success",
};

export const REPAIR_ORDER_STATUS_OPTIONS = [
  { label: "OPENED", value: "OPENED" },
  { label: "PREASSIGNED", value: "PREASSIGNED" },
  { label: "WORKING", value: "WORKING" },
  { label: "CLOSED", value: "CLOSED" },
];

export const DATE_PRESET_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "This month", value: "this_month" },
  { label: "This year", value: "this_year" },
];

export const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Number(value));
};

export const formatMileage = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "";
  }

  return `${Number(value).toLocaleString()} mi`;
};

export const formatDateDisplay = (value, format = "MMM DD, YYYY") => {
  if (!value) return "";
  return dayjs(value).isValid() ? dayjs(value).format(format) : value;
};

export const getDateRangeForPreset = (preset) => {
  const today = dayjs().startOf("day");

  switch (preset) {
    case "today":
      return {
        from: today.format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "last_7_days":
      return {
        from: today.subtract(7, "day").format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "last_30_days":
      return {
        from: today.subtract(30, "day").format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "this_month":
      return {
        from: today.startOf("month").format("YYYY-MM-DD"),
        to: today.endOf("month").format("YYYY-MM-DD"),
      };
    case "this_year":
      return {
        from: today.startOf("year").format("YYYY-MM-DD"),
        to: today.endOf("year").format("YYYY-MM-DD"),
      };
    default:
      return { from: null, to: null };
  }
};

export const getStatusColor = (status) => {
  if (!status) return "neutral";
  const normalized = status.toUpperCase();
  if (statusColorMap[normalized]) return statusColorMap[normalized];
  return "neutral";
};

